import styled from 'styled-components/macro';

export const ReminderWrapper = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
    width: 100%;
    padding: 32px;
    background-color: ${({ theme }) => theme.color.white};
    border: ${({ theme }) => theme.border.base};
    border-radius: ${({ theme }) => theme.border.radiusBase};

    svg {
        margin-bottom: 44px;
    }
`;

export const Title = styled.div`
    max-width: 380px;
    text-align: center;
    font-size: 18px;
    font-weight: 600;
    line-height: 22px;
    color: ${({ theme }) => theme.color.textBase};
    margin-bottom: 24px;
`;

export const Info = styled.div`
    max-width: 500px;
    text-align: center;
    font-size: 12px;
    font-weight: 500;
    line-height: 18px;
    color: ${({ theme }) => theme.color.textLight};
`;
